import {
  Control,
  useController,
  useFieldArray,
  useWatch,
} from 'react-hook-form';
import { getCountryCallingCode, Country } from 'react-phone-number-input';
import {
  createRequiredValidator,
  createMaxLengthValidator,
  createEmailValidator,
  isValidInput,
} from '../../Campaigns/validators';
import { CspRegistrationFormData } from '../types';

export const useContactDetailsControllers = (
  control: Control<CspRegistrationFormData>
) => {
  const phoneCountry = useWatch({ control, name: 'ui.phoneCountry' });
  const market = useWatch({ control, name: 'register.market' });

  // Phone field
  const {
    field: { value: phone, onChange: setPhone, onBlur: validatePhone },
    fieldState: { error: phoneError },
  } = useController({
    control,
    name: 'contact.phone',
    rules: {
      validate: (value: string) => {
        if (!value) return 'Please enter Phone Number';

        let dialCode = '';
        try {
          dialCode = getCountryCallingCode(phoneCountry as Country);
        } catch (_e) {
          // ignore
        }
        if (value === `+${dialCode}`) {
          return 'Please enter Phone Number';
        }
        if (phoneCountry === 'IN' && value.length > 13) {
          return 'Maximum 10 numbers allowed';
        }
        return true;
      },
    },
  });

  // Email FieldArrays
  const emailArray = useFieldArray({
    control,
    name: 'contact.email',
  });

  const financeEmailArray = useFieldArray({
    control,
    name: 'contact.financeEmail',
  });

  const techEmailArray = useFieldArray({
    control,
    name: 'contact.techEmail',
  });

  const escalateEmailArray = useFieldArray({
    control,
    name: 'contact.escalateEmail',
  });

  // Common email validator for FieldArray items
  const emailRules = {
    validate: {
      isValidInput,
      isRequired: createRequiredValidator('Required field.'),
      withValidMaxLength: createMaxLengthValidator(100),
      isEmail: createEmailValidator(),
    },
  };

  return {
    phone,
    setPhone,
    validatePhone,
    phoneError,
    market,
    // Field arrays and their utilities
    emailArray,
    financeEmailArray,
    techEmailArray,
    escalateEmailArray,
    // Validation rules to be passed to Controller in UI
    emailRules,
  };
};

export default useContactDetailsControllers;
